module.exports = __webpack_public_path__ + "img/videoclose.ad892065.svg";